<template>
  <div :class="appClass">
    <Suspense>
      <RouterView />
    </Suspense>
  </div>
</template>

<script setup lang="ts">
import { useQuasar } from 'quasar'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useBoot } from '@/composables/boot'
import iconSetCustom from '@/utils/icons'

const { bootApp } = useBoot()
const $q = useQuasar()
const route = useRoute()

const appClass = computed(() => [
  `page--${route.name?.toString()}`,
  `screen--${$q.screen.name}`,
])

$q.iconMapFn = (iconName: string) => ({ icon: iconSetCustom[iconName] })

bootApp()
</script>

<style lang="scss">
.q-notification__actions {
  align-self: start !important;
  margin: 0 !important;
}
</style>
